import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=36290d94&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"
import style0 from "../../theme/dialog.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Dialog.vue?vue&type=style&index=1&id=36290d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36290d94",
  null
  
)

export default component.exports